import React from 'react'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import Markdown from 'react-markdown'

const SectionFaq = ({ data: { loading, error, faq } }) => {
  if (error) return <h1>Error fetching the faq!</h1>
  if (!loading) {
    return (
      <article>
        <h1>{faq.question}</h1>
        <div className='Post-placeholder'>
        </div>
        <Markdown
          source={faq.content}
          escapeHtml={false}
        />
      </article>
    )
  }
  return <h2>Loading faq...</h2>
}

export const singleFaq = gql`
  query singleFaq($slug: String!) {
    faq: Faq(slug: $slug) {
      id
      slug
      question
      content
    }
  }
`

export default graphql(singleFaq, {
  options: ({ match }) => ({
    variables: {
      slug: match.params.slug
    }
  })
})(SectionFaq)



// WEBPACK FOOTER //
// ./src/pages/Faq/FaqSection.js